import Delivery from './Delivery/index.vue'
import Ontime from './Ontime/index.vue'
import Hourly from './Hourly/index'

export default [
  { path: '/qa/delivery', component: Delivery, meta: { auth: 'corp' } },
  { path: '/qa/ontime', component: Ontime, meta: { auth: 'corp' } },
  { path: '/qa/hourly', component: Hourly, meta: { auth: 'corp' } }
]